var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "custom-selection": "",
          stripe: false,
          "right-toolbar-hide": "",
          "row-key": "id",
          "reset-data": _vm.resetDataFn,
          "before-query-search": _vm.beforeQuerySearch,
          lazy: "",
          load: _vm.loadMethod,
          "row-style": _vm.$treeRowStyleFun,
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessOrderPreemptGoodsSku.preemptionStatus"
                            ),
                            prop: "preemptionStatus",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "constant-key":
                                "ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST",
                            },
                            model: {
                              value: _vm.queryParams.preemptionStatus,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "preemptionStatus",
                                  $$v
                                )
                              },
                              expression: "queryParams.preemptionStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            _vm.hasBtn
              ? {
                  key: "startBtnGroup",
                  fn: function () {
                    return [
                      !_vm.success
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.onAction(
                                    _vm.$t(
                                      "BusinessOrderPreemptGoodsSku.reReserve"
                                    )
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessOrderPreemptGoodsSku.reReserve"
                                  )
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderPreemptGoodsSku.Uncamp")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessOrderPreemptGoodsSku.Uncamp")
                            )
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "left",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : col.prop === "preemptionStatus" &&
                                          scope.row.BJ_HAS_CHILD
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                            ),
                                          ])
                                        : col.prop === "preemptionStatus" &&
                                          !scope.row.BJ_HAS_CHILD
                                        ? _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                            ),
                                          ])
                                        : col.prop === "other"
                                        ? [
                                            scope.row.BJ_HAS_CHILD
                                              ? _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BusinessOrderPreemptGoodsSku.reserve"
                                                            )
                                                          ) +
                                                          "： " +
                                                          _vm._s(
                                                            scope.row
                                                              .waitPreempCount
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BusinessOrderPreemptGoodsSku.reserveOk"
                                                            )
                                                          ) +
                                                          "： " +
                                                          _vm._s(
                                                            scope.row
                                                              .preempSuccessCount
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BusinessOrderPreemptGoodsSku.reserveFail"
                                                          )
                                                        ) +
                                                          "： " +
                                                          _vm._s(
                                                            scope.row
                                                              .preempFailCount
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            !scope.row.BJ_HAS_CHILD
                                              ? _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "BusinessOrderPreemptGoodsSku.hangUp"
                                                          )
                                                        ) +
                                                          "：" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              _vm.ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST.bjGet(
                                                                scope.row
                                                                  .suspendStatus
                                                              )
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BusinessOrderPreemptGoodsSku.giveaway"
                                                            )
                                                          ) +
                                                          "：" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              _vm.STATUS_YES_NUM.bjGet(
                                                                scope.row
                                                                  .giftFlag
                                                              )
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BusinessOrderPreemptGoodsSku.sourceStatus"
                                                            )
                                                          ) +
                                                          "： " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(
                                                                scope.row
                                                                  .sourceStatus
                                                              )
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BusinessOrderPreemptGoodsSku.virtualPosition"
                                                            )
                                                          ) +
                                                          "： " +
                                                          _vm._s(
                                                            scope.row
                                                              .virtualWarehouseName
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-other-td-item",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "BusinessOrderPreemptGoodsSku.failReason"
                                                            )
                                                          ) +
                                                          " ：" +
                                                          _vm._s(
                                                            scope.row.failReason
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      col.prop === "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDetail(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "paginationLeft",
              fn: function () {
                return [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("BusinessOrderPreemptGoodsSku.productLineTotal")
                      ) +
                        "：" +
                        _vm._s(_vm.counts.goodsQuantity) +
                        "；" +
                        _vm._s(_vm.$t("BusinessOrderPreemptGoodsSku.reserve")) +
                        "：" +
                        _vm._s(_vm.counts.waitPreempCount) +
                        "；" +
                        _vm._s(
                          _vm.$t("BusinessOrderPreemptGoodsSku.reserveOk")
                        ) +
                        "：" +
                        _vm._s(_vm.counts.preempSuccessCount) +
                        "；" +
                        _vm._s(
                          _vm.$t("BusinessOrderPreemptGoodsSku.reserveFail")
                        ) +
                        "：" +
                        _vm._s(_vm.counts.preempFailCount)
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }